import React from "react";

import Link from "../../../components/Link";
import WW2 from "../../../assets/image/ww2headquarters.png";

import style from './style.module.css';

export default function Logo() {
    return (
        <Link to="/" className={style.logo}>
            <img alt="ww2headquarters" src={WW2} />
        </Link>
    )
}